export {InputTextModule} from './input-text.module';
export * from './input-text.component';
